export default {
  dropdown: 90,
  modal: 100
};



// WEBPACK FOOTER //
// ./styles/default-theme/z-index.js